// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"3a813c31","468":"b81b1cd9"}[chunkId] + ".chunk.css";
};